<template>
  <div>
    <component
      :is="
        !already_in_container && (!all_screen || (all_screen && !visible))
          ? 'b-container'
          : 'div'
      "
    >
      <b-card :no-body="true">
        <div :class="header_background_class">
          <b-card-header @click="onclick">
            <!-- eslint-disable vue/no-v-html -->
            <span v-html="sign" />
            {{ title }}
          </b-card-header>
        </div>
        <b-collapse :id="$id('collapse')" v-model="visible">
          <b-card-body>
            <slot />
            <!-- <slot v-if="visible" /> -->
          </b-card-body>
        </b-collapse>
      </b-card>
    </component>
  </div>
</template>

<style lang="scss" scoped>
@import '@/custom-bootstrap.scss';

.available-header {
  cursor: pointer;
  background-color: $lightblue;
  color: white;
}

.pending-header {
  background-color: $lightgrey;
}

.failed-header {
  background-color: $lightred;
  color: white;
}
</style>

<script>
import _ from 'lodash'

import { tagid_mixin } from '@/components/mixin.js'

// *****************************************************************************

export default {
  name: 'UnrollElement',
  mixins: [tagid_mixin],
  props: {
    title: {
      type: String,
      default: '',
    },
    available: {
      required: true,
    },
    failed: {
      required: false,
      default: false,
    },
    all_screen: {
      default: false,
    },
    start_opened: {
      default: false,
    },
    already_in_container: {
      default: true,
    },
  },
  data() {
    return {
      visible: this.start_opened,
    }
  },
  computed: {
    sign() {
      if (this.available) {
        if (this.visible) {
          return '<span class="fas fa-minus fa-fw">'
        } else {
          return '<span class="fas fa-plus fa-fw">'
        }
      } else {
        return '<span class="fas fa-fw">'
      }
    },
    header_background_class() {
      let res
      if (this.failed) {
        res = 'failed-header'
      } else {
        res = this.available ? 'available-header' : 'pending-header'
      }
      return res
    },
  },
  watch: {
    visible: {
      immediate: true,
      handler(nv, ov) {
        if (!_.isEqual(nv, ov)) {
          this.$emit('toggled_visibility', nv)
        }
      },
    },
  },
  methods: {
    onclick() {
      if (this.available) {
        this.visible = !this.visible
      }
    },
  },
}
</script>
